import { Environment } from "./environment.interface";

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://api.dev.netgreencapital.com',
};
